export default __webpack_public_path__ + "Balanced_Lightgap_Example.jpg";